import React from 'react';
import ReactDOM from 'react-dom/client';
import { CalculateMaximumMortgageIndex, type CalculateMaximumMortgageIndexProps } from '~/pages/Tools/CalculateMaximumMortgage/Index/CalculateMaximumMortgageIndex';
import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: CalculateMaximumMortgageIndexProps;
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <CalculateMaximumMortgageIndex {...data} />
  </React.StrictMode>
)